export const StepWiseModeEnum = {
	INCREASE: 0,
	DECREASE: 1,
	ALTERNATE: 2,
}

export default StepWiseModeEnum
